import React from 'react';
import './audioAssetCard.css';

export interface AudioAssetCardAction {
  key: string;
  icon: React.ReactNode;
  title?: string;
  onClick: (e: React.MouseEvent) => void;
  disabled?: boolean;
}

export interface AudioAssetCardProps {
  audioUrl?: string | null;
  title?: string;
  subtitle?: string;
  meta?: string;
  centerAction?: {
    label: string;
    onClick: (e: React.MouseEvent) => void;
  };
  centerActions?: Array<{
    label: string;
    onClick: (e: React.MouseEvent) => void;
  }>;
  deleteAction?: {
    onClick: (e: React.MouseEvent) => void;
    busy?: boolean;
    disabled?: boolean;
  };
  footerActions?: AudioAssetCardAction[];
  variant?: 'card' | 'compact' | 'mini';
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export const AudioAssetCard: React.FC<AudioAssetCardProps> = ({
  audioUrl,
  title,
  subtitle,
  meta,
  centerAction,
  centerActions,
  deleteAction,
  footerActions,
  variant = 'card',
  onClick,
  className,
  style,
  children,
}) => {
  const hasAudio = Boolean((audioUrl || '').trim());
  const resolvedCenterActions =
    centerActions && centerActions.length > 0
      ? centerActions
      : centerAction
        ? [centerAction]
        : [];
  const rootCls = [
    'aac-root',
    `aac-root--${variant}`,
    onClick ? 'aac-root--clickable' : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootCls} style={style} onClick={onClick}>
      <div className="aac-preview">
        <div className="aac-wave" aria-hidden>
          {Array.from({ length: 6 }).map((_, i) => (
            <div className="aac-wave-bar" key={i} />
          ))}
        </div>
        {hasAudio ? (
          <span className="aac-icon" aria-hidden>
            🎵
          </span>
        ) : (
          <div className="aac-empty-preview">无音频</div>
        )}

        {resolvedCenterActions.length > 0 && (
          <div className="aac-center-overlay">
            {resolvedCenterActions.map((action, idx) => (
              <button
                key={`${action.label}-${idx}`}
                type="button"
                className="aac-center-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  action.onClick(e);
                }}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}

        {deleteAction && (
          <button
            type="button"
            className="aac-delete-btn"
            disabled={deleteAction.disabled || deleteAction.busy}
            onClick={(e) => {
              e.stopPropagation();
              deleteAction.onClick(e);
            }}
          >
            {deleteAction.busy ? '⏳' : '✕'}
          </button>
        )}
      </div>

      {(title || subtitle || meta || footerActions || children) && (
        <div className="aac-info">
          {title && <div className="aac-title">{title}</div>}
          {subtitle && <div className="aac-subtitle">{subtitle}</div>}
          {meta && <div className="aac-meta">{meta}</div>}
          {children}
          {footerActions && footerActions.length > 0 && (
            <div className="aac-footer-actions">
              {footerActions.map((action) => (
                <button
                  key={action.key}
                  type="button"
                  className="aac-footer-btn"
                  title={action.title}
                  disabled={action.disabled}
                  onClick={(e) => {
                    e.stopPropagation();
                    action.onClick(e);
                  }}
                >
                  {action.icon}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AudioAssetCard;
